export default __webpack_public_path__ + "static/media/calendar.af2392af.svg";